import React from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'
import {
  titleize,
  parseItemCondition,
  parseGradeOverall,
  displayTranslations, getArtwork, parseCategoryName, parseLanguage, compareStrings
} from "../../utils/utils";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import GameNameParser from "./GameNameParser";
import ExpansionIcon from "./ExpansionIcon";
import EncasingParser from "./EncasingParser";

const ShopOffertDetailModal = ({showShopProductDetailModal, onClose, offerToShow, handleBackNavigation, isBusinessAccount}) => {

  // Funzione che gestisce la chiusura della modale
  const handleClose = () => onClose(false)


  const blueprintImageNames = displayTranslations(offerToShow.blueprint_image.en_name, offerToShow.blueprint_image.meta_name, offerToShow.blueprint_image.language)
  const eraNames = displayTranslations(offerToShow.blueprint_image.en_era_name, offerToShow.blueprint_image.era_name, offerToShow.blueprint_image.language)
  const expansionNames = displayTranslations(offerToShow.blueprint_image.en_expansion_name, offerToShow.blueprint_image.expansion_name, offerToShow.blueprint_image.language)

  return (
    <Modal show={showShopProductDetailModal} onHide={handleClose} animation={false} size="lg" centered>
      <Modal.Header>
        <Modal.Title>{I18n.t('js.cardInfoPage.productDetail')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12 col-lg-6">
            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.name')}&nbsp;</span>
              {
                blueprintImageNames.length > 1 ?
                    <React.Fragment>
                      <span>
                        { blueprintImageNames[0] }
                      </span>
                      <span>
                        ({ blueprintImageNames[1] })
                      </span>
                    </React.Fragment>
                  :
                    <span>
                      { blueprintImageNames[0] }
                    </span>
              }
              &nbsp;
              {
                getArtwork(offerToShow.blueprint_image) ? <small>[{getArtwork(offerToShow.blueprint_image)}]</small> : <React.Fragment></React.Fragment>
              }

            </p>
            {offerToShow.blueprint_image.collector_number && offerToShow.blueprint_image.collector_number !== '' &&
            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.cn')}&nbsp;</span>
              <span>&nbsp;{offerToShow.blueprint_image.collector_number}</span>
            </p>
            }

            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.language')}&nbsp;</span>
              <span>{parseLanguage(offerToShow.blueprint_image.language_filter)}</span>
            </p>

            {
              offerToShow.blueprint_image.version &&
              <p>
                <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.version')}&nbsp;</span>
                <span>{titleize(offerToShow.blueprint_image.version)}</span>
              </p>
            }

            {
              offerToShow.blueprint_image.rarity && !compareStrings(offerToShow.blueprint_image.rarity, 'no rarity') &&
              <p>
                <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.rarity')}&nbsp;</span>
                <span>{titleize(offerToShow.blueprint_image.rarity)}</span>
                {offerToShow.blueprint_image.rarity_logo_url &&
                <img src={offerToShow.blueprint_image.rarity_logo_url} alt="" className="ml-1 mb-1"
                     style={{maxWidth: '15px'}}/>
                }
              </p>
            }

            {offerToShow.blueprint_image.edition &&
            !compareStrings(offerToShow.blueprint_image.edition, 'Undefined') && offerToShow.blueprint_image.edition !== "" &&
            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.edition')}&nbsp;</span>
              <span>{offerToShow.blueprint_image.edition}</span>
            </p>
            }

            {offerToShow.blueprint_image.print_sheet_code &&
            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.sheetCode')}&nbsp;</span>
              {offerToShow.blueprint_image.print_sheet_code}
            </p>}

            {
              offerToShow.blueprint_image.released_at && offerToShow.blueprint_image.released_at !== '' &&
              <p>
                <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.releaseAt')}&nbsp;</span>
                <span>{titleize(offerToShow.blueprint_image.released_at)}</span>
              </p>
            }

            <div className="d-flex justify-content-start mb-2">
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.brand')}&nbsp;</span>
              <GameNameParser
                game_name={offerToShow.blueprint_image.game.name}
                additionalClasses1={"mb-0"}
              />
            </div>

            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.category')}&nbsp;</span>
              <span>
                { parseCategoryName(offerToShow.blueprint_image.blueprint.category.name) }
              </span>
            </p>

            {
              eraNames.length > 1 ?
                <p>
                  <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.era')}&nbsp;</span>
                  <span>
                    { eraNames[0] }&nbsp;
                  </span>
                  <small>
                    ({ eraNames[1] })
                  </small>
                </p>
              :
                  <p>
                    <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.era')}&nbsp;</span>
                    { eraNames[0] }
                  </p>
            }

            {
              expansionNames.length > 1 ?
                <p>
                  <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.expansion')}&nbsp;</span>
                  <span>
                    { expansionNames[0] }
                  </span>
                  <small>&nbsp;
                    ({ expansionNames[1] })
                  </small>

                  <ExpansionIcon
                    icon_url={offerToShow.blueprint_image.expansion.icon_url}
                    width={'25px'}
                  />
                </p>
              :
                <p>
                  <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.expansion')}&nbsp;</span>
                  <span>
                    { expansionNames[0] }
                  </span>

                  <ExpansionIcon
                    icon_url={offerToShow.blueprint_image.expansion.icon_url}
                    width={'25px'}
                  />
                </p>
            }

            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.seller')}&nbsp;</span>
              <span>{offerToShow.user.username}&nbsp;</span>
            </p>

            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.languageAndEncasing')}&nbsp;</span>
              <span>
                <img src={window.location.origin + `/images/flags/${offerToShow.current_grading.label_language.toLowerCase()}.png`}
                     style={{ maxHeight: "20px" }}
                     className="mb-1"
                     alt=""
                /><br/>
                <EncasingParser
                  encasing={offerToShow.current_grading.encasing}
                  categoryName={offerToShow.blueprint_image.blueprint.category.name}
                />
              </span>
            </p>

            {
              isBusinessAccount &&
                <p>
                  <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.condition')}&nbsp;</span>
                  <span>{parseItemCondition(offerToShow.condition)}</span>
                </p>
            }

            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.cardGrading')}&nbsp;</span>
              <span className="mb-2 text-weight-700" style={{ color: 'green' }}>{parseGradeOverall(offerToShow.current_grading)}</span>
            </p>

            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.serialNumber')}&nbsp;</span>
              <span>{offerToShow.current_grading.serial_number}</span>
            </p>


            <p>
              <span className="text-weight-700">{I18n.t('js.shopProductDetailModal.errors')}&nbsp;</span>
              {offerToShow.current_grading.qualifier &&
              offerToShow.current_grading.qualifier !== "none"
                  ? <span>{offerToShow.current_grading.qualifier.toUpperCase().replaceAll('_', ' ')}</span>
                  : <span>{I18n.t('js.common.none')}</span>
              }
            </p>

            <div className="row mt-30px">
              {
                offerToShow.current_grading && offerToShow.current_grading.is_valid && offerToShow.current_grading.serial_number &&
                  <div className="col-6">
                    <div
                      className="text-center btn-standard bg-dark text-light pr-2 pl-2 w-90 btn-standard-resized pt-4px-imp h-auto">
                      <p className="mb-0 pt-3px-imp">
                        <a href={`/grading_certificate/${offerToShow.current_grading.serial_number}`}
                           className="text-light text--size-09rem">
                          <i className="fas fa-eye icon-in-btn-size"/> &nbsp;
                          {I18n.t('js.shopPage.viewMore')}
                        </a>
                      </p>
                    </div>
                  </div>
              }
              <div className="col-6">
                <div
                    className="text-center btn-standard bg-dark text-light pr-2 pl-2 w-90 btn-standard-resized pt-4px-imp ml-10perc h-auto"
                  onClick={(e)=>handleBackNavigation(e,offerToShow.blueprint_image)}>
                  <p className="mb-0 pt-3px-imp">
                    <a href={`/products/${offerToShow.blueprint_image.id}`}
                       className="text-light text--size-09rem">{I18n.t('js.shopProductDetailModal.compareOffers')}</a>
                  </p>
                </div>
              </div>
              <div className="col-6">

              </div>
            </div>

          </div>
          <div className="d-none d-lg-block col-6 text-center mt-30px">
            <ShowBlueprintImageFrontImage
                size={'large'}
                cursor={'auto'}
                blueprintImage={offerToShow.blueprint_image}
            />
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
          onClick={handleClose}>
          {I18n.t('js.common.ok').toUpperCase()}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ShopOffertDetailModal;